import React from 'react';
import {Box, Card, CardContent, CardHeader, Container, Grid, Typography} from '@mui/material';
import AlertMessage from "../Common/Alert/AlertMessage";
import BreadcrumbBuilder from "../Applications/CENT/BreadcrumbBuilder";

const Error404 = () =>  (

        <Container className="content">
            <Grid container spacing={3} className="card-grid">

                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                <Grid item xs={12}>

                    <Card className="card">
                        <CardHeader
                            disableTypography={true}
                            title={<Typography component="h2" variant="h2" >404</Typography>}
                        />
                        <CardContent>
                            <Box className="card-content">
                                <AlertMessage severity="error" message="Resource not found" />
                            </Box>
                        </CardContent>
                    </Card>

                </Grid>

            </Grid>
        </Container>
);

export default Error404;
